import { StatsContextPaginationInterface } from 'pf-frontend-common/src/module/stats/context/pagination.interface';

import { AgentSerpStoreStateInterface } from 'common/module/agent-serp/store/state.interface';

export class AgentSerpStatsPaginationAdapter {
  /**
   * Constructor
   */
  constructor(private agentSerpStoreState: AgentSerpStoreStateInterface) {}

  /**
   * Return agent serp state as stats pagination data
   */
  public getData(): StatsContextPaginationInterface {
    return {
      pageCurrent: this.agentSerpStoreState.params['page[number]'],
      itemPerPage: this.agentSerpStoreState.params['page[limit]'],
      itemTotal: this.agentSerpStoreState.results.count,
    };
  }
}
